// industries array (sorted alphabetically by label)
export const industries = [
	{
		id: 10,
		label: 'Automotive',
		icon: 'industry-icon-automotive.svg',
		subindustries: [
			{ id: 49, label: 'Automotive Parts', info: 'Tyres, Batteries, Brakes (e.g. Michelin)' },
			{ id: 50, label: 'Automotive Services', info: 'Breakdown services, Vehicle Repair/ Maintenance (e.g. the AA)' },
			{ id: 51, label: 'Other Automotive', info: 'If your ad’s industry doesn’t match any of the above categories' },
			{ id: 48, label: 'Vehicles', info: 'Cars, Trucks, Motorcycles (e.g. Volvo)' }
		]
	},
	{
		id: 9,
		label: 'Beauty & personal care',
		icon: 'industry-icon-beauty.svg',
		subindustries: [
			{ id: 45, label: 'Beauty & cosmetics', info: 'e.g. MaxFactor' },
			{ id: 46, label: 'Fragrances', info: 'e.g. Chanel, Old Spice' },
			{ id: 47, label: 'Other Beauty & personal care', info: 'If your ad’s industry doesn’t match any of the above categories' },
			{ id: 41, label: 'Personal care', info: 'Cleansing & hygiene (e.g. Colgate, Gilette)' }
		]
	},
	{
		id: 3,
		label: 'Clothing & Fashion',
		icon: 'industry-icon-clothing.svg',
		subindustries: [
			{ id: 17, label: 'Designer/luxury', info: 'e.g. Gucci, Rolex' },
			{ id: 16, label: 'Non-designer', info: 'e.g. Next, Sokonda' },
			{ id: 18, label: 'Other Clothing & Fashion', info: 'If your ad’s industry doesn’t match any of the above categories' }
		]
	},
	{
		id: 6,
		label: 'Food & Drink',
		icon: 'industry-icon-food.svg',
		subindustries: [
			{ id: 28, label: 'Alcoholic drinks', info: 'Beer, Wine, Spirits (e.g. Heineken)' },
			{ id: 32, label: 'Bars/Restaurants & Fast Food brands', info: 'e.g. KFC' },
			{ id: 33, label: 'Food delivery services', info: 'e.g. JustEat' },
			{ id: 30, label: 'Foods', info: 'Fresh produce, Dairy, Frozen Foods, Other Foods (e.g. Bird’s Eye)' },
			{ id: 29, label: 'Non-alcoholic drinks', info: 'Soft drinks, Juices, Water, Coffee/Tea (e.g. Coke)' },
			{ id: 34, label: 'Other Food & Drink', info: 'If your ad’s industry doesn’t match any of the above categories' },
			{ id: 31, label: 'Snacks / confectionery', info: 'e.g. Doritos' }
		]
	},
	{
		id: 8,
		label: 'Health & Medical',
		icon: 'industry-icon-health.svg',
		subindustries: [
			{ id: 44, label: 'Other Health & Medical', info: 'If your ad’s industry doesn’t match any of the above categories' },
			{ id: 42, label: 'Pharmaceutical brands (over-the-counter drugs)', info: 'e.g. Nurofen' },
			{ id: 43, label: 'Pharmaceutical brands (Prescription drugs) ', info: 'e.g. Wegovy' }
		]
	},
	{
		id: 7,
		label: 'Home & Family',
		icon: 'industry-icon-home.svg',
		subindustries: [
			{ id: 39, label: 'Home decor brands', info: 'e.g. Dulux' },
			{ id: 38, label: 'Homeware brands', info: 'e.g. Royal Copenhagen' },
			{ id: 35, label: 'Household products', info: 'e.g. Ariel' },
			{ id: 37, label: 'Furniture brands', info: 'e.g. Ercol' },
			{ id: 40, label: 'Other Home & Family', info: 'If your ad’s industry doesn’t match any of the above categories' },
			{ id: 36, label: 'Toys and hobbies', info: 'e.g. LEGO' }
		]
	},
	{
		id: 13,
		label: 'Industrial',
		icon: 'industry-icon-industrial.svg',
		subindustries: [
			{ id: 66, label: 'Construction', info: '' },
			{ id: 64, label: 'Energy infrastructure', info: '' },
			{ id: 71, label: 'Industrial engineering', info: '' },
			{ id: 65, label: 'Manufacturing', info: '' },
			{ id: 67, label: 'Materials', info: '' },
			{ id: 68, label: 'Mining and Metals', info: '' },
			{ id: 72, label: 'Other Industrial', info: 'If your ad’s industry doesn’t match any of the above categories' },
			{ id: 69, label: 'Textiles', info: '' },
			{ id: 70, label: 'Transportation and logistics', info: '' }
		]
	},
	{
		id: 5,
		label: 'News & Entertainment',
		icon: 'industry-icon-news.svg',
		subindustries: [
			{ id: 23, label: 'Events & Shows', info: '' },
			{ id: 24, label: 'Music & books', info: '' },
			{ id: 22, label: 'Movies & TV', info: 'e.g. Netflix, BBC, Disney+' },
			{ id: 26, label: 'Newspapers & Magazines', info: '' },
			{ id: 27, label: 'Other News & Entertainment', info: 'If your ad’s industry doesn’t match any of the above categories' },
			{ id: 25, label: 'Video games & platforms', info: '' }
		]
	},
	{
		id: 1,
		label: 'Retailers',
		icon: 'industry-icon-retailers.svg',
		subindustries: [
			{ id: 3, label: 'Department stores', info: 'e.g. John Lewis' },
			{ id: 6, label: 'Furniture/Home décor stores', info: 'e.g. IKEA' },
			{ id: 7, label: 'Hardware/DIY stores & Garden Centres', info: 'e.g. B&Q' },
			{ id: 5, label: 'Kitchen/Bathroom/Bedroom Design Specialists', info: '' },
			{ id: 1, label: 'Online marketplaces', info: 'e.g. Amazon' },
			{ id: 8, label: 'Other Retailers', info: 'If your ad’s industry doesn’t match any of the above categories' },
			{ id: 4, label: 'Pharmacies/Health & Beauty stores', info: 'e.g. Superdrug' },
			{ id: 2, label: 'Supermarkets / Hypermarkets', info: 'e.g. Tesco' }
		]
	},
	{
		id: 12,
		label: 'Services',
		icon: 'industry-icon-services.svg',
		subindustries: [
			{ id: 61, label: 'Business Services', info: 'Lawyers, Architects, Consultants, Agencies (e.g. PWC)' },
			{ id: 57, label: 'Educational Institutes/Services', info: 'e.g. Universities' },
			{ id: 59, label: 'Financial Services', info: 'e.g. Retail Banking, Investment Banking, Loans/Credit, Insurance' },
			{ id: 63, label: 'Other Services', info: 'If your ad’s industry doesn’t match any of the above categories' },
			{ id: 58, label: 'Telecoms & Internet Services', info: 'e.g. Vodafone' },
			{ id: 62, label: 'Tradespeople/companies', info: 'e.g. Plumbers' },
			{ id: 60, label: 'Utilities Providers', info: 'e.g. British Gas, Andel' }
		]
	},
	{
		id: 4,
		label: 'Sportswear & Sports equipment',
		icon: 'industry-icon-sports.svg',
		subindustries: [
			{ id: 21, label: 'Other Sportswear & Sports equipment', info: 'If your ad’s industry doesn’t match any of the above categories' },
			{ id: 20, label: 'Sports equipment', info: 'e.g. Salomon' },
			{ id: 19, label: 'Sportswear', info: 'e.g. Nike, Patagonia' }
		]
	},
	{
		id: 11,
		label: 'Tech & Appliances',
		icon: 'industry-icon-tech.svg',
		subindustries: [
			{ id: 55, label: 'Home appliances', info: 'TVs, Audio systems, Smart home devices, Kitchen appliances, Home/garden tools/appliances (e.g. Philips, Bosch)' },
			{ id: 56, label: 'Other Technology and Appliances', info: 'If your ad’s industry doesn’t match any of the above categories' },
			{ id: 53, label: 'PCs/laptops', info: 'e.g. Dell, Apple MacBook' },
			{ id: 54, label: 'Personal electronics', info: 'Smartphones, Tablets, Wearables, E-shaver (e.g. Philips)' },
			{ id: 52, label: 'Software (incl. cloud)', info: 'e.g. Microsoft / Salesforce' }
		]
	},
	{
		id: 2,
		label: 'Travel & Tourism',
		icon: 'industry-icon-travel.svg',
		subindustries: [
			{ id: 9, label: 'Airlines / Train companies', info: 'e.g. Lufthansa' },
			{ id: 12, label: 'Hotels', info: 'e.g. Hilton' },
			{ id: 15, label: 'Other Travel & Tourism', info: 'If your ad’s industry doesn’t match any of the above categories' },
			{ id: 11, label: 'Taxi / ride sharing', info: 'e.g. Uber' },
			{ id: 13, label: 'Travel Agents', info: 'e.g. Expedia' },
			{ id: 14, label: 'Travel Destinations', info: 'e.g. Australia' },
			{ id: 10, label: 'Vehicle Rentals', info: 'e.g. Avis' }
		]
	}
]

// get main industry by subindustry id
export function getIndustryBySubIndustryId(id) {
	return industries.find(ind => ind.subindustries.find(sub => sub.id === id) !== undefined)
}

// get subindustry by id
export function getSubindustryById(id) {
	return getIndustryBySubIndustryId(id).subindustries?.find(sub => sub.id === id)
}

// get all subindustries by main industry id
export function getSubindustriesById(id) {
	return industries.find(ind => ind.id === id).subindustries
}